import { render } from "./Detail.vue?vue&type=template&id=65606d42&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=65606d42&lang=less"
import "./Detail.vue?vue&type=style&index=1&id=65606d42&lang=less&scoped=true"

import exportComponent from "/data/app_data/product_data/deploy-center-mars/s3-deploy/damocstp/panel-cspt/v1.4.2-20260320-150211/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65606d42"]])

export default __exports__